'use strict';

import Calendar from './calendar/Calendar.service'

const state = {}

const actions = {
  ...Calendar.actions,
}

const mutations = {}

const getters = {}

export default { getters, actions, mutations, state }